module.exports = __webpack_public_path__ + "img/talk_show.8fab360f.png";